import React from "react"
import { Checkout } from "../../components"

const CheckoutUser = () =>{
    return(
        <Checkout />
    )
}

export default CheckoutUser